import { createApp } from 'vue'
import App from './App.vue'
import '@mybonet/design/main.css'
import './style.css'
import { API_BASE } from './api'
import { installVueErrorReporting } from './clientLog'

const app = createApp(App)
installVueErrorReporting(app, API_BASE, 'app-platform')
app.mount('#app')
